module.exports = __webpack_public_path__ + "static/media/azah-logo-jp.accc593c.jpg";